import { render, staticRenderFns } from "./MejoraPreca.vue?vue&type=template&id=8812ade4&scoped=true&lang=html&"
import script from "./MejoraPreca.vue?vue&type=script&lang=js&"
export * from "./MejoraPreca.vue?vue&type=script&lang=js&"
import style0 from "./MejoraPreca.vue?vue&type=style&index=0&id=8812ade4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8812ade4",
  null
  
)

export default component.exports